import { useState } from "react";
import lsApi from "../api/lsApi";
import { DatosAbonosTipo, DatosMovimientosMensuales } from "../models/graficas";

export function useGraficas() {
    /*consultas para grafica de barras Movimientos mensuales*/
    const [año, setAño] = useState<string>(`${new Date().getFullYear()}-01`);
    const currentYear = Number(año.split('-')[0]);

    const [movimientosMensuales, setMovimientosMensuales] = useState<DatosMovimientosMensuales[]>([]);


    const getMovimientosMensuales = async (anio: number) => {
        try {
            const { data, status } = await lsApi.get<DatosMovimientosMensuales[]>(`/api/ControlAcceso/MovimientosMensuales?INANIO=${anio}`);
            if (status === 200) {
                setMovimientosMensuales(data);
            } else {
                setMovimientosMensuales([]);
            }
        } catch (err) {
            console.error(err);
            setMovimientosMensuales([]);

        }
    };

    /*logica para grafica pie Abonos por tipo*/

    const [añoAbonos, setAñoAbonos] = useState<string>(`${new Date().getFullYear()}`);
    const [mesAbonos, setMesAbonos] = useState<string>(`${new Date().getMonth()+1}`);
    const currentYearAbonos = Number(año.split('-')[0]);

    const [datosAbonos, setDatosAbonos] = useState<DatosAbonosTipo[]>([]);


    const getAbonosTipo = async () => {
        try {
            const { data, status } = await lsApi.get<DatosAbonosTipo[]>(`/api/ControlAcceso/IngresoPorTipo?INGPANIO=${añoAbonos}&INGPMES=${mesAbonos}`);
            if (status === 200) {
                setDatosAbonos(data);
            } else {
                setDatosAbonos([]);
            }
        } catch (err) {
            console.error(err);
            setDatosAbonos([]);

        }
    };




    return {
        /*Movimientos grafico Barras */
        getMovimientosMensuales,
        currentYear,
        setAño,
        año,
        movimientosMensuales,
        /*abonos grafico pIE*/
        getAbonosTipo,
        setAñoAbonos,
        añoAbonos,
        mesAbonos,
        setMesAbonos,
        currentYearAbonos,
        datosAbonos,
    }
}